// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications .list-move{transition:transform .3s,opacity .4s}.notifications .list-item{display:inline-block}.notifications .list-enter-active{transition:transform .2s ease-in,opacity .4s ease-in}.notifications .list-leave-active{transition:transform 1s ease-out,opacity .4s ease-out}.notifications .list-enter{opacity:0;transform:scale(1.1)}.notifications .list-leave-to{opacity:0;transform:scale(1.2,.7)}", ""]);
// Exports
module.exports = exports;
